import { useEffect, useRef } from "react";
import { APIProvider, useMapsLibrary } from "@vis.gl/react-google-maps";

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

function AutocompleteInput({ value, onChange, onSelect, placeholder, testid }) {
  const places = useMapsLibrary("places");
  const inputRef = useRef(null);
  const acRef = useRef(null);

  useEffect(() => {
    if (!places || !inputRef.current) return;
    acRef.current = new places.Autocomplete(inputRef.current, {
      fields: ["formatted_address", "geometry", "place_id", "name"],
    });
    const listener = acRef.current.addListener("place_changed", () => {
      const place = acRef.current.getPlace();
      const address = place.formatted_address || place.name || "";
      const loc = place.geometry?.location;
      const lat = loc ? loc.lat() : null;
      const lng = loc ? loc.lng() : null;
      const maps_url = place.place_id
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}&query_place_id=${place.place_id}`
        : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
      onSelect({ address, place_id: place.place_id || null, lat, lng, maps_url });
    });
    return () => listener?.remove();
  }, [places, onSelect]);

  return (
    <input
      ref={inputRef}
      data-testid={testid}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="w-full border border-zinc-200 px-3 py-2 text-sm outline-none focus:border-[#e84e34]"
    />
  );
}

export default function AddressAutocomplete(props) {
  if (!API_KEY) {
    return (
      <input
        data-testid={props.testid}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value)}
        placeholder={props.placeholder}
        className="w-full border border-zinc-200 px-3 py-2 text-sm outline-none focus:border-[#e84e34]"
      />
    );
  }
  return (
    <APIProvider apiKey={API_KEY}>
      <AutocompleteInput {...props} />
    </APIProvider>
  );
}
